<template>
  <header>
    <div :class="['header__area', {'header__transparent' : !header__white && !isSticky}, {'white-bg' : header__white || isSticky}]" id="header-sticky">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-2 col-sm-4 col-6">
            <div class="header__left d-flex">
              <div class="logo">
                <router-link to="/">
                  <img src="../../assets/img/logo/gelisimpturkiye-logo.png" alt="logo">
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-xxl-9 col-xl-9 col-lg-8 col-md-10 col-sm-8 col-6">
            <div class="header__right d-flex justify-content-end align-items-center">
              <div class="main-menu d-none d-xl-block">
                <nav>
                  <ul>
                    <li>
                      <router-link to="/">Ana Sayfa</router-link>
                    </li>
                    <li>
                      <router-link to="/about">Hakkımızda</router-link>
                    </li>
                    <li>
                      <router-link to="/contact">İletişim</router-link>
                    </li>
                  </ul>
                </nav>
              </div>
              <div class="sidebar__menu d-xl-none">
                <div class="sidebar-toggle-btn" @click="sidebar_toggle">
                  <div class="bar-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobil menü -->
    <div :class="['sidebar__area', {'sidebar-opened' : sidebar}]">
      <div class="sidebar__wrapper">
        <div class="sidebar__close">
          <button class="sidebar__close-btn" @click="sidebar_toggle">
            <span><i class="fal fa-times"></i></span>
          </button>
        </div>
        <div class="sidebar__content">
          <div class="logo mb-40">
            <router-link to="/">
              <img src="../../assets/img/logo/gelisimpturkiye-logo.png" alt="logo">
            </router-link>
          </div>
          <div class="mobile-menu">
            <nav>
              <ul>
                <li>
                  <router-link to="/">Ana Sayfa</router-link>
                </li>
                <li>
                  <router-link to="/about">Hakkımızda</router-link>
                </li>
                <li>
                  <router-link to="/contact">İletişim</router-link>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <!-- Mobil menü overlay -->
    <div :class="['body-overlay', {'opened' : sidebar}]" @click="sidebar_toggle"></div>
  </header>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'

export default {
  name: 'MainHeader',
  props: {
    header__white: {
      type: String
    }
  },
  setup() {
    const sidebar = ref(false)
    const isSticky = ref(false)

    const sidebar_toggle = () => {
      sidebar.value = !sidebar.value
    }

    const handleScroll = () => {
      if (window.scrollY > 80) {
        isSticky.value = true
      } else {
        isSticky.value = false
      }
    }

    onMounted(() => {
      window.addEventListener('scroll', handleScroll)
    })

    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll)
    })

    return {
      sidebar,
      isSticky,
      sidebar_toggle
    }
  }
}
</script>

<style scoped>
.header__area {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
  transition: all 0.3s ease;
}

.header__transparent {
  background: transparent;
}

.white-bg {
  background: #fff;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
}

.logo img {
  max-height: 100px;
}

.main-menu ul {
  display: flex;
  margin: 0;
  padding: 0;
  list-style: none;
}

.main-menu ul li {
  margin: 0 20px;
}

.main-menu ul li a {
  color: #0e1133;
  font-size: 16px;
  font-weight: 500;
  padding: 25px 0;
  display: block;
  text-decoration: none;
  transition: all 0.3s ease;
}

.main-menu ul li a:hover {
  color: #2b4eff;
}

.sidebar-toggle-btn {
  width: 30px;
  height: 30px;
  padding: 5px;
  cursor: pointer;
}

.bar-icon span {
  display: block;
  width: 100%;
  height: 2px;
  background: #0e1133;
  margin: 5px 0;
  transition: all 0.3s ease;
}

.sidebar__area {
  position: fixed;
  right: -100%;
  top: 0;
  width: 300px;
  height: 100%;
  background: #fff;
  z-index: 999;
  transition: all 0.3s ease;
  padding: 30px;
}

.sidebar-opened {
  right: 0;
}

.sidebar__close-btn {
  position: absolute;
  top: 25px;
  right: 25px;
  font-size: 20px;
  border: none;
  background: none;
  color: #0e1133;
  cursor: pointer;
}

.body-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  z-index: 99;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.body-overlay.opened {
  opacity: 1;
  visibility: visible;
}

.mobile-menu ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.mobile-menu ul li {
  margin: 15px 0;
}

.mobile-menu ul li a {
  color: #0e1133;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  display: block;
  transition: all 0.3s ease;
}

.mobile-menu ul li a:hover {
  color: #2b4eff;
}

@media (max-width: 1199px) {
  .main-menu {
    display: none !important;
  }
}
</style>